import { EntityService } from '../../../service/EntityService';

export class PetrolimexService extends EntityService {

  static entity = 'app/petrolimex';
  static updateChangeTax(data: any): Promise<any> {
    return this.axios.put(`${this.entity}/change-tax`, data).then(res => res.data);
  }
  static getListHistory(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/history`, { params }).then(res => res.data);
  }

  static deleteMulti(ids: Array<string>): Promise<any> {
    return this.axios.post(`${this.entity}/multi-delete`, ids).then(res => res.data);
  }
}
